interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): (number | string)[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) pages.push('start-ellipsis');
  for (let current = start; current <= end; current += 1) pages.push(current);
  if (end < totalPages - 1) pages.push('end-ellipsis');
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  const baseBtn =
    'flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md border px-3 text-sm transition-colors';

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className={`${baseBtn} border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700`}
      >
        <i className="ri-arrow-left-s-line" />
      </button>

      {pages.map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? 'page' : undefined}
            className={`${baseBtn} ${
              item === page
                ? 'border-primary-500 bg-primary-500 font-semibold text-background-50'
                : 'border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600'
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="flex h-9 w-6 items-center justify-center text-sm text-foreground-400">
            …
          </span>
        ),
      )}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className={`${baseBtn} border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700`}
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}